import './calendar.css'

import moment from 'moment'
import React, { useState, useEffect } from 'react'

import * as DateUtils from '../utils/data'
import CalendarNavigation from './CalendarNavigation/CalendarNavigation'
import CalendarTable from './CalendarTable/CalendarTable'

function Calendar({ todo, setSelectedDay, selectedDay }) {
  useEffect(() => {
    DateUtils.startWeekFromMonday()
  }, [])

  const [selectMonthValue, setSelectMonthValue] = useState(() => DateUtils.getCurrentMonth())
  const [selectYearValue, setSelectYearValue] = useState(() => DateUtils.getCurrentYear())

  const [currentWindowCalendar, setCurrentWindowCalendar] = useState(() =>
    createAllDaysForCurrWindow(DateUtils.getCurrentYear(), DateUtils.getCurrentMonth()),
  )
  console.log(currentWindowCalendar)
  useEffect(() => {
    setCurrentWindowCalendar(createAllDaysForCurrWindow(selectYearValue, selectMonthValue))
  }, [selectMonthValue, selectYearValue])

  return (
    <div className="calendar">
      <CalendarNavigation
        setSelectYearValue={setSelectYearValue}
        setSelectMonthValue={setSelectMonthValue}
        setSelectedDay={setSelectedDay}
        setCurrentWindowCalendar={setCurrentWindowCalendar}
        createValuesCurrWindow={createAllDaysForCurrWindow}
        selectMonthValue={selectMonthValue}
        selectYearValue={selectYearValue}
      />
      <CalendarTable
        currentWindowCalendar={currentWindowCalendar}
        selectedDay={selectedDay}
        selectMonthValue={selectMonthValue}
        setSelectedDay={setSelectedDay}
        todo={todo}
      />
    </div>
  )
}

export default React.memo(Calendar)

function createOneDay(newDay, selectMonthValue) {
  return {
    id: DateUtils.getId(newDay),
    date: {
      day: DateUtils.getDayOfMonth(newDay),
      month: DateUtils.getMonthOfYear(newDay),
      year: DateUtils.getYear(newDay),
    },
    isWeekend: DateUtils.isWeekend(newDay),
    isCurrentMonth: DateUtils.isCurrentMonth(newDay, selectMonthValue),
    isToday: DateUtils.isToday(newDay),
  }
}

function createAllDaysForCurrWindow(year, month, day = 1) {
  const selectedDay = moment().set({ year: year, month: month, date: day })
  const startDay = selectedDay.clone().startOf('month').startOf('week')
  const currDay = startDay.subtract(1, 'day').clone()
  const resultArrAllDays = [...Array(42)].map(() => createOneDay(currDay.add(1, 'day').clone(), month))

  return resultArrAllDays
}
